import { DialogComponent } from '@theme/dialog';

const TRIGGER_SELECTOR = 'a[href$="#be-season-reports"]';

/**
 * The season reports overlay: a hidden, pre-rendered dialog on the Land page
 * (sections/season-reports.liquid) built from the `season_report` metaobject
 * entries. Every year is listed newest-first — a year heading above its
 * detail — so the overlay is a plain scrolling archive with no year switching.
 *
 * Any anchor whose href ends in `#be-season-reports` opens it, so a plain
 * button block (link set to #be-season-reports) is the trigger — no bespoke
 * markup needed. The trigger is a visible on-page link, so the native <dialog>
 * focus restore returns focus to it on close; no custom focus handling here.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog - The dialog element.
 *
 * @extends DialogComponent
 */
class SeasonReportsComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('click', this.#handleTriggerClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this.#handleTriggerClick);
  }

  /**
   * Opens the overlay in place of following a trigger link (the link's
   * #be-season-reports href is an inert no-JS fallback).
   *
   * @param {MouseEvent} event - The click event.
   */
  #handleTriggerClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest(TRIGGER_SELECTOR);

    if (!link || this.contains(link)) return;

    event.preventDefault();
    this.showDialog();
  };
}

if (!customElements.get('be-season-reports-component')) {
  customElements.define('be-season-reports-component', SeasonReportsComponent);
}
